import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-number',
    template: `
          <div class="d-flex align-items-center justify-content-center">
            <input type="number"  [formControl]="formControl" class="form-control number custom-form-control" id="form-control"  placeholder="{{to.placeholder}}"
              autocomplete="off" description="xx" [ngStyle]="to['precision'] && {'min-width':'80px'}">
            @if (to['precision']!== null && to['precision']) {
              <span style="margin-left:6px;margin-right:6px;padding-top: 29px;" class="label-preview">.</span>
            }
            @if (to['precision']!== null && to['precision']) {
              <input type="number"  [formControl]="formControl" class="form-control number" id="form-control"
                autocomplete="off" style="margin-left:2px;min-width:80px;">
            }
            @if (to['unit']!== null && to['unit']) {
              <span style="margin-left:2px;" class="label-preview">{{to['unit']}}</span>
            }
          </div>
          
          <div style="position: absolute;bottom:2px;left:0;right:0;display:flex">
            @if (to.min || to.min == 0) {
              <label class="label-preview-title pb-3 ps-4">Min : {{to.min}}</label>
            }
            @if (to.max || to.max == 0) {
              <label class="label-preview-title ps-2 pb-3">Max : {{to.max}}</label>
            }
          </div>
          
          
          @if (showError && formControl.errors) {
            <div class="alert alert-danger" role="alert">
              <formly-validation-message [field]="field"></formly-validation-message>
            </div>
          }
          `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomNumber extends FieldType<FieldTypeConfig> {
  get type() {
    return this.to.type || 'text';
  }
}